module.exports = __webpack_public_path__ + "static/media/block.73560a0f.svg";